var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('button',{on:{"click":_vm.go}},[_vm._v("111")])])}
var staticRenderFns = []

export { render, staticRenderFns }